import React, { useEffect, useState } from "react";
import "./style.scss";
import editIcon from "../../../assets/icons/edit-icon-white.svg";
import checkedIcon from "../../../assets/icons/checked_icon_white.svg";
import questionMarkIcon from "../../../assets/icons/question_mark_white.svg";
import bankWireIcon from "../../../assets/icons/bankWire_icon_blue.svg";
import wise from "../../../assets/icons/wise.webp";
import swiftIcon from "../../../assets/icons/swift_icon_blue.svg";
import achIcon from "../../../assets/icons/ach_icon_blue.svg";
import Rise from "../../../assets/images/rise.svg";
import VeriffIMG from "../../../assets/images/veriff.jpg";

import AddressDetails from "../AddressDetails";
import { getAllBankDetails } from "../../../utils/apis/payments";
import { useDispatch, useSelector } from "react-redux";
import BankModal from "./BankModal";
import { getVeriffLink, getVeriffStatus } from "../../../utils/apis/userApi";
import { returnMessages } from "../../../utils/store/reducers/Message";
import { returnErrors } from "../../../utils/store/reducers/Error";
const Kyc = () => {
  const [checkVerify, setCheckVerify] = useState([]);
  const { idToken } = useSelector((state) => state.auth);
  const fetchPaymentMethods = async (value) => {
    const response = await getAllBankDetails(idToken);

    setCheckVerify(response);
  };
  useEffect(() => {
    fetchPaymentMethods();
  }, []);

  const getImages = (img) => {
    switch (img) {
      case "rise":
        return Rise;
      case "wire":
        return bankWireIcon;
      case "swift":
        return swiftIcon;
      case "ach":
        return achIcon;
      case "wise":
        return wise;
      default:
        return questionMarkIcon;
    }
  };
  const getDesc = (desc) => {
    switch (desc) {
      case "rise":
        return "Get paid with Rise for convenient and seamless transactions.";
      case "wire":
        return "Get paid with Wire for convenient and seamless transactions.";
      case "swift":
        return "Get paid with Swift for convenient and seamless transactions.";
      case "ach":
        return "Get paid with Ach for convenient and seamless transactions.";
      case "wise":
        return "Get paid with Wise for convenient and seamless transactions.";
      default:
        return "Get paid with Rise for convenient and seamless transactions.";
    }
  };
  const kycData = checkVerify.map((verify) => ({
    isVerified: verify?.is_verified ? true : false,
    icon: getImages(verify?.settlement_type?.toLowerCase()),
    name: verify?.settlement_type?.toUpperCase(),
    desc: getDesc(verify?.settlement_type?.toLowerCase()),
    status: true,
    itemValue: verify,
  }));

  const VeriffData = [
    {
      isVerified: checkVerify?.is_verified ? true : false,
      icon: VeriffIMG,
      name: "Veriff",
      desc: "One verification platform to secure the whole user journey. Secure every step of the your customer journey.",
      actionBtn: "Verify",
    },
  ];

  useEffect(() => {
    fetchKycVeriffStatus();
  }, []);
  const dispatch = useDispatch();
  const [activeAddress, setActiveAddress] = useState();
  const [isVisible, setIsVisible] = useState(false);
  const [isEditVisible, setIsEditVisible] = useState(false);
  const [kycVeriffStatus, setKycVeriffStatus] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const fetchKycVeriffStatus = async () => {
    const response = await getVeriffStatus(idToken);
    setKycVeriffStatus(response?.data);
  };
  const fetchVerifyLink = async () => {
    try {
      setIsLoading(true);
      const response = await getVeriffLink(idToken);

      if (
        response?.data?.status === "success" ||
        response?.data?.verification
      ) {
        window.location.replace(response?.data?.verification?.url);
        return;
      }
      if (response.status === 200) {
        dispatch(returnMessages(response?.data?.detail, 200));
        setIsLoading(false);
      }
      if (response.response.status > 201) {
        dispatch(returnErrors(response?.response?.data?.detail, 500));
      }
      setIsLoading(false);
      // Handle the case where the response status is not 200

      fetchKycVeriffStatus();
    } catch (error) {
      console.error("Error fetching Veriff link:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const VeriffDATA = ({ item, index }) => {
    return (
      <div className="kycData_container">
        <div className="kycData_wrapper">
          <div
            className={`verification_status ${
              kycVeriffStatus?.review_status === "approved" ||
              kycVeriffStatus?.is_verified === true
                ? "verified"
                : kycVeriffStatus?.review_status === "pending"
                ? "pending"
                : "notVerified"
            }`}
          >
            <img
              src={
                kycVeriffStatus?.review_status === "approved" ||
                kycVeriffStatus?.is_verified === true
                  ? checkedIcon
                  : questionMarkIcon
              }
              alt=""
            />
            <p style={{ textTransform: "capitalize" }}>
              {kycVeriffStatus?.review_status === "approved" ||
              kycVeriffStatus?.is_verified === true
                ? "Verified"
                : kycVeriffStatus?.review_status}
            </p>
          </div>
          <div className="kycData_desc">
            <div className="header_container">
              <img style={{ maxHeight: "30px" }} src={item.icon} alt="" />
              <p>{item.name}</p>
            </div>
            <div className="desc">
              <p>{item.desc}</p>
            </div>
          </div>
          <div className="button_wrapper">
            <button
              className="edit_button"
              onClick={fetchVerifyLink}
              style={{
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
              disabled={isLoading}
            >
              {isLoading ? "Verifying..." : "Verify"}
            </button>
          </div>
        </div>
      </div>
    );
  };
  const [itemValue, setItemValue] = useState();
  const KycData = ({ item, index }) => {
    return (
      <div className="kycData_container">
        <div className="kycData_wrapper">
          {/* <div
            className={`verification_status ${
              item.isVerified === true ? "verified" : "notVerified"
            }`}
          >
            <img
              src={item.isVerified === true ? checkedIcon : questionMarkIcon}
              alt=""
            />
            <p>{item.isVerified === true ? "Verified" : "Unverified"}</p>
          </div> */}
          <div className="kycData_desc">
            <div className="header_container">
              <img style={{ maxHeight: "30px" }} src={item.icon} alt="" />
              <p>{item.name}</p>
            </div>
            <div className="desc">
              <p>{item.desc}</p>
            </div>
          </div>
          <div className="button_wrapper">
            <button
              className="edit_button"
              onClick={() => (
                item?.status ? setIsEditVisible(!isEditVisible) : "",
                setItemValue(item.itemValue)
              )}
            >
              {item?.status ? (
                <>
                  Edit <img src={editIcon} alt="" />
                </>
              ) : (
                "Coming Soon..."
              )}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="kyc_container">
        <div className="header_wrapper" style={{ margin: "15px 0" }}>
          <h2>Payout Details</h2>
        </div>

        <div className="kyc_wrapper">
          {kycData.map((item, index) => (
            <KycData key={item.id} item={item} index={index} />
          ))}
        </div>
        <div className="header_wrapper" style={{ margin: "15px 0" }}>
          <h2>KYC</h2>
        </div>

        <div className="kyc_wrapper">
          {VeriffData.map((item, index) => (
            <VeriffDATA key={item.id} item={item} index={index} />
          ))}
        </div>
      </div>
      <div className="kyc_address_container">
        <AddressDetails />
      </div>
      {(isEditVisible || isVisible) && (
        <div className="addressModal">
          <div
            className="addressModalOverlay"
            onClick={() => {
              setIsEditVisible(false);
              setIsVisible(false);
            }}
          >
            <BankModal
              fetchPaymentMethods={fetchPaymentMethods}
              itemValue={itemValue}
              setIsVisible={setIsVisible}
              isVisible={isVisible}
              setIsEditVisible={setIsEditVisible}
              isEditVisible={isEditVisible}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Kyc;
